import { oss_baseUrl } from '@/config'; // oss 图片地址
import Public from './public';
import moment from 'moment';
/**
 * 货币格式化-过滤器
 * (1234,2) => ￥1234.00
 * (1234,2,$) => $1234.00
 * (1234,2,'') => 1234.00
 */
function moneyFmt(value, decimals = 2, symbol = '￥') {
    const val = parseFloat(value);
    if (isNaN(val)) {
        return value;
    }

    const money = val.toFixed(decimals);
    return `${symbol}${money}`;
}

/**
 * 日期格式化-过滤器
 * 根据format格式化日期str
 * 2018-01-01 14:16:13 (yyyy/MM/dd hh-mm-ss) => 2018/01/01 14-16-13
 * 2018-01-01 14:16:13 (yy/M/d h-m) => 18/01/01 14-16
 * 2018-01-01 14:16:13 (yyMMdd) => 180101
 * 2018-01-01 (yyyyMM) => 201801
 * 14:16:13 (hh:mm) => 14:16
 */
function dateFmt(value, format = 'YYYY-MM-dd hh:mm:ss') {
    if (!value) {
        return;
    }
    const dateObj = parse(value);
    const year = dateObj.year;
    const month = dateObj.month;
    const day = dateObj.day;
    const hour = dateObj.hour;
    const minute = dateObj.minute;
    const second = dateObj.second;

    let str = format;
    str = str.replace(/yyyy|YYYY/, year);
    str = str.replace(/yy|YY/, year % 100 > 9 ? (year % 100).toString() : '0' + (year % 100));

    str = str.replace(/MM|M/g, month);

    str = str.replace(/dd|DD|d|D/g, day);

    str = str.replace(/hh|HH|h|H/g, hour);

    str = str.replace(/mm|m/g, minute);

    str = str.replace(/ss|SS|s|S/g, second);

    return str;

    // 解析日期string->{year,month...},参数格式可以是datetime/date/time
    function parse(dateStr) {
        const dateObj = {
            year: '',
            month: '',
            day: '',
            hour: '',
            minute: '',
            second: ''
        };
        if (typeof dateStr !== 'string') {
            return dateObj;
        }

        const arr = dateStr.split(' ');
        if (arr.length > 1) {
            // datetime
            const _date = arr[0].split('-');
            dateObj.year = _date[0];
            dateObj.month = _date[1];
            dateObj.day = _date[2];
            const _time = arr[1].split(':');
            dateObj.hour = _time[0];
            dateObj.minute = _time[1];
            dateObj.second = _time[2];
        } else if (arr.length === 1) {
            // date or time
            if (arr[0].indexOf('-') > -1) {
                // date
                const _date = arr[0].split('-');
                dateObj.year = _date[0];
                dateObj.month = _date[1];
                dateObj.day = _date[2];
            } else if (arr[0].indexOf(':') > -1) {
                // time
                const _time = arr[0].split(':');
                dateObj.hour = _time[0];
                dateObj.minute = _time[1];
                dateObj.second = _time[2];
            }
        }

        return dateObj;
    }
}

/**
 * 字符串长度溢出格式化-过滤器
 */
function ellipsis(value, len) {
    let type = typeof value;
    if (type != 'string') {
        value = value.toString();
    }

    return value.length > len ? value.substr(0, len) + '...' : value;
}

/**
 * 中间变星号
 * phone 手机号
 * bank 银行卡
 * IDcode 身份证
 */
function star(value, type) {
    if (!value) {
        return;
    }
    if (type == 'phone') {
        return value.substr(0, 3) + '****' + value.substr(7);
    } else if (type == 'bank') {
        return '************' + value.substr(12);
    } else if (type == 'IDcode') {
        return value.substr(0, 1) + '****************' + value.substr(17);
    }
}

/**
 * 距离值格式化-过滤器
 * 854 => '<854km'
 * 1234 => '<1.2km'
 * 5678 => '<5.7km'
 */
function distanceFmt(value) {
    value = parseFloat(value);
    let str = '';
    if (value < 1000) {
        str = `${value.toFixed(0)}m`;
    } else {
        str = `${(value / 1000).toFixed(1)}km`;
    }
    return str;
}

/**
 * 满减活动格式化-过滤器
 */
function activityFmt(act) {
    if (!act.money) {
        return '';
    }
    if (act.type == 1) {
        // 1满减
        return `满${act.money}减${act.dis}`;
    } else {
        // 2折扣
        return `满${act.money}打${parseFloat(act.dis * 10)}折`;
    }
}

/**
 * 订单状态-过滤器
 *
 *
 *
 */
function orderState([type, status]) {
    let str = '';
    const orderType = Public.orderType;
    const orderStatus = Public.orderStatus;
    if (type === orderType.takeIn) {
        switch (status) {
            case orderStatus.waitPay:
                str = '待付款';
                break;
            case orderStatus.waitReceipt:
                str = '待自提（未接单）';
                break;
            case orderStatus.waitDeliver:
                str = '待自提（已接单）';
                break;
            case orderStatus.refuse:
                str = '待自提（拒绝接单）';
                break;
            case orderStatus.cancelOrder:
                str = '订单取消';
                break;
            case orderStatus.hasReceived:
                str = '已自提';
                break;
            case orderStatus.success:
                str = '订单完成';
                break;
            case orderStatus.fail:
                str = '订单关闭';
                break;
        }
    } else {
        switch (status) {
            case orderStatus.waitPay:
                str = '待付款';
                break;
            case orderStatus.waitReceipt:
                str = '待发货（未接单）';
                break;
            case orderStatus.waitDeliver:
                str = '待发货（已接单）';
                break;
            case orderStatus.refuse:
                str = '待发货（拒绝接单）';
                break;
            case orderStatus.cancelOrder:
                str = '订单关闭';
                break;
            case orderStatus.waitReceived:
                str = '待收货';
                break;
            case orderStatus.hasReceived:
                str = '已收货';
                break;
            case orderStatus.success:
                str = '订单完成';
                break;
            case orderStatus.fail:
                str = '订单关闭';
                break;
        }
    }
    return str;
}

/**
 * 售后状态-过滤器
 *
 *
 *
 */
function refundState(status) {
    let str = '';
    const afterStatus = Public.afterStatus;
    switch (status) {
        case afterStatus.waitExamine:
            str = '等待商家审核';
            break;
        case afterStatus.returnGoods:
            str = '商家已同意退货，请及时退回';
            break;
        case afterStatus.waitReceived:
            str = '等待商家确认收货';
            break;
        case afterStatus.examineFail:
            str = '审核未通过，退款关闭';
            break;
        case afterStatus.cancelAfter:
            str = '售后已撤销，退款关闭';
            break;
        case afterStatus.success:
            str = '退款成功';
            break;
    }
    return str;
}

/**
 * 静态图片组装格式化-过滤器
 * name 图片名称
 * path 图片路径 默认static
 * type 图片格式 （jpg,png）
 */
function imageFmt(name, type = 'png', path = 'static') {
    return `${oss_baseUrl}/${path}/${name}.${type}`;
}
/**
 * 时间间隔过滤器
 * @param {String} time 创建时间
 */
function timeFmt(time) {
    let startTime = moment(time); // 开始时间
    let endTime = moment(); // 结束时间
    let second = Math.floor((endTime - startTime) / 1000);
    let minute = Math.floor((endTime - startTime) / 1000 / 60);
    let hour = Math.floor((endTime - startTime) / 1000 / 60 / 60);
    let day = Math.floor((endTime - startTime) / 1000 / 60 / 60 / 24);
    if (day > 0) {
        return day + '天';
    } else if (hour > 0 && hour < 24) {
        return hour + '小时';
    } else if (minute > 0 && minute < 60) {
        return minute + '分钟';
    } else if (second > 0 && second < 60) {
        return second + '秒';
    }
    // console.log(endTime - startTime); // 毫秒数
    // console.log(Math.floor((endTime - startTime) / 1000)); // 秒数
    // console.log(Math.floor((endTime - startTime) / 1000 / 60)); // 分钟
    // console.log(Math.floor((endTime - startTime) / 1000 / 60 / 60)); // 小时
    // console.log(Math.floor((endTime - startTime) / 1000 / 60 / 60 / 24)); // 天数return `${oss_baseUrl}/${path}/${name}.${type}`;
}

export default {
    moneyFmt,
    dateFmt,
    ellipsis,
    star,
    distanceFmt,
    activityFmt,
    orderState,
    refundState,
    imageFmt,
    timeFmt
};
